import axiosInstance from '@/app/api/axiosInstance';
import { Site, SiteCreate, SiteUpdate, PaginatedResponse, ListQueryParams } from '@/app/types';

export const listSites = async (params: ListQueryParams & { show_all?: boolean }): Promise<PaginatedResponse<Site>> => {
  try {
    const response = await axiosInstance.get<PaginatedResponse<Site>>('/sites/', {
      params
    });
    return response.data;
  } catch (error) {
    console.error('Failed to list sites:', error);
    throw error;
  }
};

export const getSite = async (siteId: number): Promise<Site> => {
  try {
    console.log(`Calling getSite with ID: ${siteId}`);
    const response = await axiosInstance.get<Site>(`/sites/${siteId}`);
    console.log('getSite response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to get site with ID ${siteId}:`, error);
    throw error;
  }
};

export const createSite = async (data: SiteCreate): Promise<Site> => {
  try {
    const response = await axiosInstance.post<Site>('/sites/', data);
    return response.data;
  } catch (error) {
    console.error('Failed to create site:', error);
    throw error;
  }
};

export const updateSite = async (siteId: number, data: SiteUpdate): Promise<Site> => {
  try {
    console.log(`Calling updateSite with ID: ${siteId}, data:`, data);
    const response = await axiosInstance.patch<Site>(`/sites/${siteId}`, data);
    console.log('updateSite response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update site with ID ${siteId}:`, error);
    throw error;
  }
};

export const deleteSite = async (siteId: number): Promise<void> => {
  try {
    console.log(`Calling deleteSite with ID: ${siteId}`);
    await axiosInstance.delete(`/sites/${siteId}`);
    console.log('deleteSite successful');
  } catch (error) {
    console.error(`Failed to delete site with ID ${siteId}:`, error);
    throw error;
  }
}; 